import * as React from 'react';
import { observer } from 'mobx-react';

// Types
import { FieldState } from 'formstate';

type IOption = {
  label: string;
  value: string;
};

// Components
import { MenuItem } from '../Menu';
import TextField from '../TextField';

// Component
interface IProps {
  label?: string;
  fieldState: FieldState<string>;
  options: IOption[];
  margin?: 'none' | 'normal' | 'dense';
  fullWidth?: boolean;
  helperText?: string;
}

function Select(props: IProps) {
  return (
    <TextField
      id="select-currency-native"
      select={true}
      label={props.label}
      value={props.fieldState.value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.fieldState.onChange(e.target.value)}
      error={props.fieldState.hasError}
      helperText={props.fieldState.error || props.helperText}
      onBlur={
        props.fieldState.dirty
          ? props.fieldState.enableAutoValidationAndValidate
          : undefined
      }
      margin={props.margin}
      fullWidth={props.fullWidth}
    >
      {props.options.map(item => (
        <MenuItem key={item.value} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default observer(Select);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FormStateFields/Select.tsx